import script from "./FaqSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqSection.vue?vue&type=script&setup=true&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=9f06bed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f06bed4"]])

export default __exports__